export default {
  Tech: 'rgb(207, 223, 255)',
  'Fill/Finish': 'rgb(208, 240, 253)',
  Adjuvant: 'rgb(194, 245, 233)',
  'Source of materials': 'rgb(209, 247, 196)',
  'Distribution and storage': 'rgb(255, 234, 182)',
  'Start to finish product': 'rgb(254, 226, 213)',
}
